let userProfileStyle = {
  userProfile: {
    display: "flex",
    flexDirection: "column",
  },

  uname: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },

  userProfileInfo: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-evenly",
  },

  userProfileMeta: {
    display: "flex",
    flexDirection: "column",
  },

  userProfileMetrics: {
    display: "flex",
  },

  userProfileMetricsItem: {
    marginLeft: "10px",
  },

  hr: {
    width: "100%",
  },

  profilePic: {
    width: "150px",
    height: "150px",
    borderRadius: "50%",
  },

  profilePicDiv: {
    paddingTop: "15px",
  },
};

export default userProfileStyle;
